//*-*-*-*-*-*-*-*-*-*-*-*
//  START OF DOM READY
//*-*-*-*-*-*-*-*-*-*-*-*
$(document).ready(function() {
	$(document).on('click','.conditionText',function(e){
		e.preventDefault();
    	$(this).next('.popupOverlay').addClass('open');
	});
  
  	$(document).on('click','.sizeGuideText',function(e){
		e.preventDefault();
    	$(this).next('.popupOverlay').addClass('open');
	});
  
  	$(document).on('click','#inches',function(e){
		e.preventDefault();
      	$('#centimeters').removeClass('active');
     	$('.centimetersSection').fadeOut();
      	$(this).delay(500).addClass('active');
    	$('.inchesSection').delay(500).fadeIn();
	});
  
    $(document).on('click','#centimeters',function(e){
		e.preventDefault();
      	$('#inches').removeClass('active');
     	$('.inchesSection').fadeOut();
      	$(this).delay(500).addClass('active');
    	$('.centimetersSection').delay(500).fadeIn();
	});
  
  
    $(document).on('click','.closePopup',function(){
      $(this).parent().parent('.popupOverlay').removeClass('open');
    });
  
    $(document).on('click','.closePopupX',function(){
      $(this).parent().parent('.popupOverlay').removeClass('open');
    });
  
  	$('.sizeGuideSlider').slick({
		fade:false,
		dots:true,
		arrows:true,
		autoplay: true
	});
  
  var filterGoCollection = function(takenewterm){
    var patha = window.location.protocol;
    var pathb = window.location.host;
    window.location.href = patha+'//'+pathb+takenewterm; 
  };
  jQuery("#SortMonth").change(function(){
    var selectedcollection = jQuery(this).children("option:selected").val();
    filterGoCollection(selectedcollection);
  });
  jQuery("#SortType").change(function(){
    var selectedcollection = jQuery(this).children("option:selected").val();
    filterGoCollection(selectedcollection);
  });
  
  $(document).on('click','.revealBar',function(e){
    e.preventDefault();
    $(this).parent('.rte').toggleClass('expanded');
    if ($(this).parent('.rte').hasClass("expanded")) {
    	$('.revealBar').html('Read Less');
    } else {
     	$('.revealBar').html('Read More');
    }
  });

  //var $carousel = $('#rare-archive-spinner').flickity()
  // let $selects = $('select');
  // if($selects.length){
  //   console.log("There is at least one select on this page");
  //   for(let i=0; i<$selects.length; i++){
  //     const titleString = $($selects[i]).attr('id')
  //     if(titleString.includes("SingleOptionSelector")){
  //       const $select = $($selects[i]);
  //       const idString = titleString.split("-")[1];
  //       const $radio = $(`input:radio[name=RadioOptionSelector-${idString}]`)
  //       $radio.on('change', function(){
  //         $select.val($radio.filter(':checked').val()).trigger('change');
  //       })
  //       $radio.filter("[selected]").trigger('click');
  //     }
  //   };
  // };

  let $selects = $('select');
  if ($selects.length) {
      console.log("There is at least one select on this page");
      for (let i = 0; i < $selects.length; i++) {
          const $select = $($selects[i]);
          const titleString = $select.attr('id');
          if (titleString && titleString.includes("SingleOptionSelector")) {
              const $variantInputWrap = $select.closest('.variant-input-wrap');
              const dataIndex = $variantInputWrap.data('index'); // Get the unique data-index
              const $radio = $variantInputWrap.find('input:radio');
  
              $radio.on('change', function () {
                  $select.val($(this).val()).trigger('change');
              });
  
              // Trigger click on the initially selected radio button
              $variantInputWrap.find('input:radio[selected]').trigger('click');
          }
      }
  }
});
//*-*-*-*-*-*-*-*-*-*-*-*
//   END OF DOM READY
//*-*-*-*-*-*-*-*-*-*-*-*

$(window).on('load',function(){
  //window.dispatchEvent(new Event('resize'));
  if($('#rare-archive-spinner').length){
    let flkty = new Flickity('#rare-archive-spinner')
    flkty.resize()
    forceResizeAgainFFS(flkty)
  }
});

async function forceResizeAgainFFS(flkty){
  for(let i=1; i < 5; i++){
    await nonblockingSleep(i*500)
    //console.log(`Attempting resize, attempt: ${i}`)
    flkty.resize()
  }
}

function nonblockingSleep(ms){
  return new Promise(resolve => setTimeout(resolve, ms))
}

$(window).on('load scroll', function(){

});

class readMore {
    constructor() {
        this.content = '.readmore__content';
        this.buttonToggle = '.readmore__toggle';
    }

    bootstrap() {
        this.setNodes();
        this.init();
        this.addEventListeners();
    }

    setNodes() {
        this.nodes = {
            contentToggle: document.querySelector(this.content)
        };

        this.buttonToggle = this.nodes.contentToggle.parentElement.querySelector(this.buttonToggle);
    }

    init() {
        const { contentToggle } = this.nodes;

        this.stateContent = contentToggle.innerHTML;

        contentToggle.innerHTML = `${this.stateContent.substring(0, 100)}...`;
    }

    addEventListeners() {
        this.buttonToggle.addEventListener('click', this.onClick.bind(this))
    }

    onClick(event) {
        const targetEvent = event.currentTarget;
        const { contentToggle } = this.nodes

        if (targetEvent.getAttribute('aria-checked') === 'true') {
            targetEvent.setAttribute('aria-checked', 'false')
            contentToggle.innerHTML = this.stateContent;
            this.buttonToggle.innerHTML = 'Read less'

        } else {
            targetEvent.setAttribute('aria-checked', 'true')
            contentToggle.innerHTML = `${this.stateContent.substring(0, 100)}...`
            this.buttonToggle.innerHTML = 'Read more'
        }
    }
}


const initReadMore = new readMore();
initReadMore.bootstrap()
